import React from 'react';
import ShowContainer from './ShowContainer';
import CusItemTooltip from './CusItemTooltip';

export default function CusTooltip({ text, bgColor }) {
  return (
    <ShowContainer condition={text}>
      <CusItemTooltip text={text} bgColor={bgColor} />
    </ShowContainer>
  );
}
